import { createSlice } from '@reduxjs/toolkit'
import {postWorkshopList,postWorkshopCount, getWorkshopAdmin, getBrands, getNetworks, getServices, getCategories} from "./thunks"

const initialState= { 
  list: {
    pageIndex: 0,
    totalRecords: 15,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  loadingCount: "idle",
  loadingBrands: "idle",
  loadingNetworks: "idle",
  loadingServices: "idle",
  loadingCategories: "idle",
  brands: [],
  networks: [],
  categories: [],
  services: [],
  error: null }

const workshopAdminSlice = createSlice({
  name: 'workshopAdmin',
  initialState,
  reducers: {
    clearWorkshopError:(state)=>{
      state.error= null
    },
    setWorkshopFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [getWorkshopAdmin.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getWorkshopAdmin.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.list= action.payload
    },
    [getWorkshopAdmin.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
    },
    [getBrands.pending]: (state)=>{
      state.loadingBrands = "loading";
      state.error = null
    },
    [getBrands.fulfilled]: (state, action) =>{
      state.brands = action.payload;
      state.loadingBrands = "succeeded"
    },
    [getBrands.rejected]: (state, action) =>{
      state.loadingBrands = "failed";
      state.error = action.error.message
    },
    [getNetworks.pending]: (state)=>{
      state.loadingNetworks = "loading";
      state.error = null
    },
    [getNetworks.fulfilled]: (state, action) =>{
      state.networks = action.payload;
      state.loadingNetworks = "succeeded"
    },
    [getNetworks.rejected]: (state, action) =>{
      state.loadingNetworks = "failed";
      state.error = action.error.message
    },
    [getServices.pending]: (state)=>{
      state.loadingServices = "loading";
      state.error = null
    },
    [getServices.fulfilled]: (state, action) =>{
      state.services = action.payload;
      state.loadingServices = "succeeded"
    },
    [getServices.rejected]: (state, action) =>{
      state.loadingServices = "failed";
      state.error = action.error.message
    },
    [getCategories.pending]: (state)=>{
      state.loadingCategories = "loading";
      state.error = null
    },
    [getCategories.fulfilled]: (state, action) =>{
      state.categories = action.payload;
      state.loadingCategories = "succeeded"
    },
    [getCategories.rejected]: (state, action) =>{
      state.loadingCategories = "failed";
      state.error = action.error.message
    },
    // [postWorkshopCount.pending]: (state) => {
    //   state.loadingCount = "loading"; 
    //   state.error = null
    // },
    // [postWorkshopCount.fulfilled]: (state, action) => {
    //   state.loadingCount = "succeeded";
    //   state.list.pageIndex = action.payload.pageIndex;
    //   state.list.totalRecords = action.payload.totalRecords;
    //   state.list.totalPages = action.payload.totalPages;
    //   state.list.hasPreviousPage = action.payload.hasPreviousPage;
    //   state.list.hasNextPage =action.payload.hasNextPage;

    // },
    // [postWorkshopCount.rejected]: (state, action) => {
    //   state.loadingCount = "failed"; 
    //   state.error = action.error.message
    // }
  }
})

export const {clearWorkshopError, setWorkshopFilters} = workshopAdminSlice.actions

export default workshopAdminSlice.reducer
